import { noop } from "lodash-es";
import type { RouteLocationNormalized } from "vue-router";

import { captureException } from "@/error/sentry";
import { loadRouteModal, queryWithoutModal } from "@/store/modal";

export function startLoadingModal(to: RouteLocationNormalized) {
  loadRouteModal(to)?.catch(noop);
}

export async function awaitModal(to: RouteLocationNormalized) {
  const loading = loadRouteModal(to);
  if (!loading) return;
  const loaded = await loading.catch((error) => {
    captureException(error, { navigation: { to: to.fullPath } });
  });
  if (!loaded) {
    return routeWithoutModal(to);
  }
}

function routeWithoutModal(to: RouteLocationNormalized) {
  return { path: to.path, query: queryWithoutModal(to.query), hash: to.hash };
}
